import './lncanada2/style';
import FormStructure from './lncanada2/form_structure';

export default FormStructure;